"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomBulletModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const Option_style_1 = require("./Option.style");
function CustomBulletModal({ title, optionPickerProps, onClickOutside, }) {
    const clickOutsideRef = ui_common_components_1.hooks.useClickOutside(onClickOutside);
    return ((0, jsx_runtime_1.jsxs)(Option_style_1.StyledCustomBulletOptionModal, { ref: clickOutsideRef, children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'SmallHeavy', children: title }), (0, jsx_runtime_1.jsx)(Option_style_1.StyledCustomBulletOptionWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.OptionPicker, Object.assign({}, optionPickerProps)) })] }));
}
exports.CustomBulletModal = CustomBulletModal;
//# sourceMappingURL=CustomBulletModal.js.map